import { AppConfig } from '@/types/global';

import valuation from './valuation';
import blog from './blog';
import home from './home';
import destination from './destination';
import object from './object';
import post from './post';
import catalog from './catalog';
import contacts from './contacts';
import notFound from './notFound';

 
const pages: Record<string, (config: any) => void> = {
  valuation,
  blog,
  home,
  destination,
  object,
  post,
  catalog,
  contacts,
  notFound
};

const initPages = (config: AppConfig): void => {
  const name = Object.keys(pages).find((page) => config[page as keyof AppConfig]);

  if (name) {
    pages[name](config);
  }
};

export default initPages;
